import React, {useRef, useEffect, useState} from 'react'
import {createPortal} from 'react-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 32px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  box-sizing: border-box;

  .modal-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
  }

  @media only screen and (max-width: 420px) {
    padding: 32px 16px;
  }
`

const useModal = () => {
  const [modalOpened, setModalOpened] = useState(false)
  const openModal = () => {
    setModalOpened(true)
  }

  const closeModal = () => {
    setModalOpened(false)
  }

 
  const ModalPortal = ({children}) => {
    const ref = useRef()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
      setMounted(true)
      if (document) {
        const dom = document.body
        ref.current = dom
      }
      return(() => {
        ref.current.style.overflow = 'auto';
      })
    }, [])
    
    if (ref.current && mounted && modalOpened) {
      ref.current.style.overflow = 'hidden';
      return createPortal(
        <Container>
          <div
            className='modal-background'
            role='presentation'
            onClick={closeModal}
          />
          {children}
        </Container>,
        ref.current
      )
    }
    return null
  }

  return {
    openModal,
    closeModal,
    ModalPortal,
  }
}

//이제 다른곳에서 useModal을 사용하여 모달을 열고 닫는 함수와,모달내부 콘텐츠를 표시해줄 컴포넌트를 불러올수있다.
export default useModal
